import React, { Suspense, lazy } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './AuthContext';
import { LanguageProvider } from './LanguageContext';
import { ThemeProvider } from './ThemeContext';
import ProtectedRoute from './ProtectedRoute';
import Layout from './Layout';
import Login from './Login';
import OwnProfile from './OwnProfile';
import Dashboard from './Dashboard';
import Finance from './Finance';
import RH from './RH';
import Administration from './Administration';
import CRM from './CRM';
import Production from './Production';
import Actifs from './Actifs';
import GED from './GED';
import TaxonomyDiagnostics from './diagnostics/TaxonomyDiagnostics';
import LocalPilotSummary from './LocalPilotSummary';
import FinanceBudgetProvider from './FinanceBudgetContext';
import { ProductionServiceSessionProvider } from './ProductionSharedServiceCyclePanel';

const Boussole = lazy(() => import('./Boussole'));

const boussoleFallback = (
  <div
    className="flex h-screen items-center justify-center bg-slate-950"
    role="status"
    aria-label="Chargement de la Boussole"
  >
    <span className="h-8 w-8 animate-spin rounded-full border-2 border-slate-600 border-t-blue-400" />
  </div>
);

const App = () => {
  return (
    <Router>
      <AuthProvider>
        <LanguageProvider>
          <ThemeProvider>
            <FinanceBudgetProvider>
            <ProductionServiceSessionProvider>
            <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/account" element={<ProtectedRoute><Layout><OwnProfile /></Layout></ProtectedRoute>} />

            {/* Routes avec Layout (sidebar sur toutes les pages) */}
            <Route
              path="/"
              element={
                <ProtectedRoute>
                  <Layout>
                    <Dashboard />
                  </Layout>
                </ProtectedRoute>
              }
            />

            {/* ÉTAPE 2 Routes */}
            <Route
              path="/finance"
              element={
                <ProtectedRoute>
                  <Layout>
                    <Finance />
                  </Layout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/rh"
              element={
                <ProtectedRoute>
                  <Layout>
                    <RH />
                  </Layout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/administration"
              element={
                <ProtectedRoute>
                  <Layout>
                    <Administration />
                  </Layout>
                </ProtectedRoute>
              }
            />

            {/* ÉTAPE 3 Routes */}
            <Route
              path="/crm"
              element={
                <ProtectedRoute>
                  <Layout>
                    <CRM />
                  </Layout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/production"
              element={
                <ProtectedRoute>
                  <Layout>
                    <Production />
                  </Layout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/actifs"
              element={
                <ProtectedRoute>
                  <Layout>
                    <Actifs />
                  </Layout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/ged"
              element={
                <ProtectedRoute>
                  <Layout>
                    <GED />
                  </Layout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/boussole"
              element={
                <ProtectedRoute>
                  <Suspense fallback={boussoleFallback}>
                    <Boussole />
                  </Suspense>
                </ProtectedRoute>
              }
            />
            <Route
              path="/diagnostics/taxonomie"
              element={
                <ProtectedRoute>
                  <Layout>
                    <TaxonomyDiagnostics />
                  </Layout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/diagnostics/pilotes-locaux"
              element={
                <ProtectedRoute>
                  <Layout>
                    <LocalPilotSummary />
                  </Layout>
                </ProtectedRoute>
              }
            />

            <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
            </ProductionServiceSessionProvider>
            </FinanceBudgetProvider>
          </ThemeProvider>
        </LanguageProvider>
      </AuthProvider>
    </Router>
  );
};

export default App;
